import React from "react";

const KunjunganPasienContext = React.createContext();

const VisitSensusContext = React.createContext();

const SepuluhBesarContext = React.createContext();

const LB1Context = React.createContext();

const LabContext = React.createContext();

const CountLabContext = React.createContext();

const CountLabHeaderContext = React.createContext();

const SanitasiContext = React.createContext();

const KesehatanLingkunganContext = React.createContext();
const SkdrContext = React.createContext();

export {
  KunjunganPasienContext,
  VisitSensusContext,
  SepuluhBesarContext,
  LB1Context,
  LabContext,
  CountLabContext,
  SanitasiContext,
  KesehatanLingkunganContext,
  CountLabHeaderContext,
  SkdrContext,
};
